const paths = {
  '': 'playNow',
  '/game-info': 'gameInfo',
  '/history': 'history',
  '/leaderboard': 'leaderboard',
  '/onboarding': 'onboarding',
};

const pathMap = (routeBase) => {
  const pathsWithBase = {};
  for (const path of Object.keys(paths)) {
    pathsWithBase[routeBase + path] = paths[path];
  }
  return pathsWithBase;
};

export { pathMap };
